// istanbul ignore file

enum BookingMethod {
    EnOnly = 1,
    AppointmentOnly = 2,
    EnOrAppointment = 3,
    EnPreference = 4,
    AppointmentPreference = 5
}

export { BookingMethod };
